













































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default Vue.extend({
  components: {
    MagnifyIcon,
    CloseIcon,
  },

  data() {
    return {
      searchTerm: '',
    };
  },

  computed: {
    ...mapGetters({
      subjectSearchResult: 'subjectSearchResult',
    }),
  },

  mounted() {
    if (this.isMobileSearch) {
      this.$refs.searchTerm.focus();
    }
  },

  methods: {
    resetSearch() {
      this.searchTerm = '';
      this.updateContent();
    },
    updateContent: function() {
      this.$emit('input', { searchTerm: this.searchTerm });

      if (!this.searchTerm) {
        this.$store.commit('CLEAN_SUBJECT_SEARCH');
        this.$emit('clearSearch');
      }
    },
    updateSearch(searchTerm: string) {
      this.hasSearched = false;
      this.searchTerm = searchTerm;
      this.updateContent();
    },
    async searchSubjects() {
      await this.$store.dispatch('PULL_SEARCH_RESULTS', this.searchTerm);
      this.$emit('pulledSearchResults', this.searchTerm);
    },
  },
});
